import React from 'react'
import { useState } from "react";
import {
  LayoutGrid, MapPin, FileText, Activity, Target, Settings,
  Search, SlidersHorizontal, Phone, MessageSquare, Plus, Minus,
  Navigation, ArrowDown, ArrowUp,
} from "lucide-react";

const ORDERS = [
  {
    id: "#98095792354", product: "Construction Materials", status: "In Transit",
    depDate: "06.05.2022", depTime: "10:00 AM", depAddr: "12 N 13th Avenue, Laurel,ms. 39440 USA",
    arrDate: "08.05.2022", arrTime: "03:00 PM", arrAddr: "17 Sunlight Cove, Spring Hope,nc. 23882 USA",
    driver: "Vincent Grand", customer: "Frank Roberts", weight: "0.67kg", price: "$68", tint: "#d8895b",
  },
  {
    id: "#98095792354", product: "Food", status: "Completed",
    depDate: "06.05.2022", depTime: "10:00 AM", depAddr: "11 S 19Ist Place, Seattle,wa. 98188 USA",
    arrDate: "08.05.2022", arrTime: "03:00 PM", arrAddr: "32 Eagle Street, Albany,ny. 12202 USA",
    driver: "Vincent Grand", customer: "Maria Chen", weight: "2.4kg", price: "$42", tint: "#6b8fd8",
  },
  {
    id: "#98095792354", product: "Furniture", status: "Delivered",
    depDate: "06.05.2022", depTime: "10:00 AM", depAddr: "12 Sweet Bay Court, Altamonte, 32314 USA",
    arrDate: "08.05.2022", arrTime: "03:00 PM", arrAddr: "17 Sunlight Cove, Spring Hope,nc. 23882 USA",
    driver: "Vincent Grand", customer: "Daniel Okoro", weight: "18kg", price: "$210", tint: "#7bb88f",
  },
];

const TABS = ["Order Details", "Driver Information", "Vehicle", "Customer Information", "Documents"];
const STATUS_COLOR = { "In Transit": "#1a8fd1", Completed: "#f5a24b", Delivered: "#6dbf6d" };

const css = `
.td{
--blue:#1a8fd1;
 --ink:#14213d;
 --muted:#7d8597;
 --line:#e8ebf0;
 --bg:#f4f6f9;
  font-family:"Poppins","Inter",system-ui,sans-serif;
  color:var(--ink);
  background:var(--bg);
  display:flex;
  height:100vh;
  min-height:560px;
  font-size:11px;
  overflow:hidden;
}

.td-orders::-webkit-scrollbar {
  width: 8px; 
}

.td-orders::-webkit-scrollbar-track {
  background: #ffffff; 
  border-radius: 4px;  
}

.td-orders::-webkit-scrollbar-thumb {
  background: #3b82f6; 
  border-radius: 4px; 
}

.td-orders::-webkit-scrollbar-thumb:hover {
  background: #3b82f6;
}


.td *{
box-sizing:border-box
}


.td-webkit-scrollbar {
  width: 8px; 
}

.td-webkit-scrollbar-track {
  background: #f0f0f0; /* Color of the scrollbar track/background */
  border-radius: 4px;  /* Optional: rounds the corners of the track */
}

.td::-webkit-scrollbar-thumb {
  background: #cccccc; 
  border-radius: 4px;  
}

.td-webkit-scrollbar-thumb:hover {
  background: #999999; /* Color of the handle on hover */
}


.td button{
font:inherit;
cursor:pointer;
border:0;
background:none;
color:inherit
}

.td button:focus-visible,
.td input:focus-visible{outline:2px solid var(--blue);outline-offset:2px}
.td-nav{width:76px;background:var(--blue);display:flex;flex-direction:column;align-items:center;padding:24px 0;gap:6px}
.td-nav button{width:100%;height:46px;display:grid;place-items:center;color:#fff;opacity:.85;position:relative}
.td-nav button[aria-current=true]{opacity:1;background:#fff2}
.td-nav button[aria-current=true]::before{content:"";position:absolute;left:0;top:8px;bottom:8px;width:3px;background:#fff;border-radius:0 3px 3px 0}
.td-me{margin-top:auto;width:34px;height:34px;border-radius:8px;background:#e9b98c;border:2px solid #fff8}

.td-list{width:min(34%,340px);
min-width:290px;
background:#fff;
padding:18px 18px 0;
display:flex;
flex-direction:column;
gap:14px
margin:10px;
}


.td-search{
display:flex;
align-items:center;
gap:8px;
padding:0 12px;
height:36px;
border-radius:10px;
background:#fff;
box-shadow:0 2px 12px #14213d14;
color:var(--muted)
}

.td-search input{
flex:1;
border:0;
outline:0;
font:inherit;
background:none
}

.td h2{
font-size:12px;
font-weight:600;
margin:0
}

.td-orders{
overflow-y:auto;
display:flex;
flex-direction:column;
gap:12px;
padding:2px 6px 18px;
}




.td-card{border:1px solid var(--line);border-radius:10px;background:#fff;box-shadow:0 2px 10px #14213d0d;text-align:left;width:100%;padding:0}
.td-card[aria-pressed=true]{border-color:var(--blue);box-shadow:0 0 0 1px var(--blue)}
.td-head{display:flex;justify-content:space-between;align-items:flex-start;padding:12px 12px 10px}
.td-head small,.td-lbl{color:var(--muted);font-size:9px;display:block}
.td-head b{font-size:10px;font-weight:600;display:block;margin-top:3px}
.td-head>div+div{flex:1;margin-left:14px}
.td-pill{color:#fff;font-size:9px;padding:4px 12px;border-radius:12px;white-space:nowrap}
.td-route{display:grid;grid-template-columns:62px 1fr;gap:2px 10px;padding:0 12px 10px;border-bottom:1px solid var(--line)}
.td-route time{color:var(--muted);font-size:9px;line-height:1.5}
.td-stop{display:flex;gap:8px;padding:4px 0}
.td-dot{width:8px;height:8px;border-radius:50%;margin-top:3px;flex:none;border:2px solid var(--blue);background:#fff}
.td-dot.end{background:var(--ink);border-color:var(--ink)}
.td-stop span{display:block;font-size:9px;color:var(--muted)}
.td-stop b{font-weight:500;font-size:9px}
.td-foot{display:flex;align-items:center;gap:10px;padding:10px 12px}
.td-av{width:30px;height:30px;border-radius:7px;display:grid;place-items:center;color:#fff;font-weight:600;font-size:11px;flex:none}
.td-foot .who{flex:1}.td-foot .who b{display:block;font-size:10px;font-weight:600}
.td-foot .who span{font-size:9px;color:var(--muted)}
.td-foot .who i{display:inline-block;width:6px;height:6px;border-radius:50%;margin-right:4px}
.td-ic{width:26px;height:26px;border-radius:50%;display:grid;place-items:center;color:var(--blue);background:#1a8fd114}
.td-map{flex:1;position:relative;background:#eef0f3;overflow:hidden}
.td-map svg.bg{position:absolute;inset:0;width:100%;height:100%}
.td-tag{position:absolute;background:#fff;border-radius:6px;box-shadow:0 2px 10px #14213d1f;padding:6px 10px;font-size:9px;display:flex;gap:6px;align-items:center}
.td-tag.top{top:7%;left:24%;flex-direction:column;align-items:flex-start;padding:10px 16px;gap:3px}
.td-tag.top b{font-size:10px;font-weight:600}
.td-tag .a{width:20px;height:20px;border-radius:5px;background:#f0f2f5;display:grid;place-items:center}
.td-zoom{position:absolute;right:16px;top:55%;display:flex;flex-direction:column;background:#fff;border-radius:16px;box-shadow:0 2px 8px #14213d1f}
.td-zoom button{width:26px;height:26px;display:grid;place-items:center;color:var(--blue)}
.td-locate{position:absolute;right:16px;top:calc(55% + 70px);width:28px;height:28px;border-radius:50%;background:#fff;display:grid;place-items:center;color:var(--blue);box-shadow:0 2px 8px #14213d1f}
.td-panel{position:absolute;left:16px;right:16px;bottom:16px;background:#fff;border-radius:10px;box-shadow:0 4px 20px #14213d26;padding:0 16px 14px}
.td-tabs{display:flex;gap:26px;border-bottom:1px solid var(--line)}
.td-tabs button{padding:10px 0;font-size:9px;color:var(--muted);border-bottom:2px solid transparent;margin-bottom:-1px}
.td-tabs button[aria-selected=true]{color:var(--ink);font-weight:600;border-color:var(--blue)}
.td-who2{display:flex;align-items:center;gap:10px;margin:12px 0}
.td-who2 .td-av{width:36px;height:36px}
.td-who2 b{display:block;font-size:11px;font-weight:600}.td-who2 span{font-size:9px;color:var(--muted)}
.td-who2 .td-pill{margin-left:auto}
.td-facts{display:flex;gap:46px}.td-facts b{display:block;font-size:10px;font-weight:600;margin-top:3px}
@media(max-width:820px){
.td{flex-direction:column;overflow:auto;height:auto}
.td-nav{flex-direction:row;width:100%;padding:6px}
.td-nav button{height:40px}.td-me{margin:0 0 0 auto}
.td-list{width:100%;min-width:0}.td-map{min-height:520px}
.td-tabs{overflow-x:auto;gap:16px}
.td-tabs button{white-space:nowrap}
.td-facts{gap:20px;flex-wrap:wrap}}
`;



function MapBackdrop() {
  return (
    <svg className="bg" viewBox="0 0 800 560" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <rect width="800" height="560" fill="#eef0f3" />
      <path d="M-20 120 Q120 60 260 110 T520 60 T820 130 V-10 H-20Z" fill="#e3ecdc" />
      <path d="M560 470 Q700 430 830 500 V570 H560Z" fill="#e3ecdc" />
      <g stroke="#fff" strokeWidth="9" fill="none" strokeLinecap="round">
        <path d="M-10 250 Q200 170 420 215 T820 150" />
        <path d="M150 -10 Q210 200 120 360 T200 570" />
        <path d="M480 -10 Q460 200 520 330 T470 570" />
        <path d="M-10 420 Q200 380 380 430 T820 400" />
      </g>
      <g stroke="#fff" strokeWidth="4" fill="none" strokeLinecap="round">
        <path d="M60 60 L300 180 M300 20 L360 290 M600 90 L700 330 M620 250 L810 300" />
        <path d="M30 330 L330 330 M400 520 L760 470 M250 450 L260 570 M660 400 L640 570" />
      </g>
      <path d="M300 205 Q430 190 540 215" stroke="#7fc79a" strokeWidth="1.5" strokeDasharray="4 4" fill="none" />
    </svg>
  );
}

function RouteOverlay() {
  return (
    <svg className="bg" viewBox="0 0 800 560" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <path d="M660 170 C560 200 520 230 505 290 C490 340 470 330 470 335 C470 370 500 380 520 362"
        stroke="#1a8fd1" strokeWidth="2" fill="none" />
      <circle cx="660" cy="170" r="5" fill="#fff" stroke="#1a8fd1" strokeWidth="2" />
      <circle cx="520" cy="362" r="5" fill="#14213d" stroke="#fff" strokeWidth="2" />
      <circle cx="475" cy="332" r="20" fill="#1a8fd1" opacity=".22" />
      <circle cx="475" cy="332" r="9" fill="#1a8fd1" stroke="#fff" strokeWidth="2" />
    </svg>
  );
}

function Avatar({ name, tint, size }) {
  const initials = name.split(" ").map((w) => w[0]).join("");
  return <span className="td-av" style={{ background: tint, ...(size && { width: size, height: size }) }}>{initials}</span>;
}

const Travelconsole = () => {
  const [selected, setSelected] = useState(0);
  const [tab, setTab] = useState(TABS[0]);
  const [query, setQuery] = useState("");
  const order = ORDERS[selected];

  const visible = ORDERS.map((o, i) => ({ o, i })).filter(({ o }) =>
    `${o.product} ${o.id} ${o.depAddr} ${o.arrAddr}`.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="td">
      <style>{css}</style>

      <nav className="td-nav" aria-label="Main">
        {[LayoutGrid, MapPin, Target].map((Icon, i) => (
          <button key={i} aria-current={i === 0} aria-label={["Dashboard", "Locations", "Tracking"][i]}>
            <Icon size={18} />
          </button>
        ))}
        <span className="td-me" />
      </nav>

      <section className="td-list" aria-label="Active orders">
        <label className="td-search mb-5">
          <Search size={14} />
          <input placeholder="Search..." value={query} onChange={(e) => setQuery(e.target.value)} />
          <SlidersHorizontal size={14}  />
        </label>
        <h2>&nbsp; Active Trips</h2>

        <div className="td-orders mt-5">
          {visible.length === 0 && <p style={{ color: "var(--muted)" }}>No orders match your search.</p>}
          {visible.map(({ o, i }) => (
            <button key={i} className="td-card" aria-pressed={i === selected} onClick={() => setSelected(i)}>
              <div className="td-head">
                <div><small>Order ID</small><b>{o.id}</b></div>
                <div><small>Name of product</small><b>{o.product}</b></div>
                <span className="td-pill" style={{ background: STATUS_COLOR[o.status] }}>{o.status}</span>
              </div>
              <div className="td-route">
                <time>{o.depDate}<br />{o.depTime}</time>
                <div className="td-stop"><i className="td-dot" /><div><span>Departure</span><b>{o.depAddr}</b></div></div>
                <time>{o.arrDate}<br />{o.arrTime}</time>
                <div className="td-stop"><i className="td-dot end" /><div><span>Arrival</span><b>{o.arrAddr}</b></div></div>
              </div>
              <div className="td-foot">
                <Avatar name={o.driver} tint={o.tint} />
                <div className="who">
                  <b>{o.driver}</b>
                  <span><i style={{ background: o.status === "In Transit" ? "#1a8fd1" : "#6dbf6d" }} />{o.status === "In Transit" ? "In Transit" : "Completed"}</span>
                </div>
                <span className="td-ic"><Phone size={13} /></span>
                <span className="td-ic"><MessageSquare size={13} /></span>
              </div>
            </button>
          ))}
        </div>
      </section>

      <section className="td-map" aria-label="Live map">
        <MapBackdrop />
        <RouteOverlay />

        <div className="td-tag top">
          <b>{order.id}</b>
          <span style={{ color: "var(--muted)" }}>
            <i style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: STATUS_COLOR[order.status], marginRight: 6 }} />
            {order.status}
          </span>
        </div>
        <div className="td-tag" style={{ top: "28%", right: "4%", maxWidth: 190 }}>
          <span className="a"><ArrowDown size={11} /></span>{order.depAddr}
        </div>
        <div className="td-tag" style={{ top: "63%", left: "56%", maxWidth: 190 }}>
          <span className="a"><ArrowUp size={11} /></span>{order.arrAddr}
        </div>

        <div className="td-zoom">
          <button aria-label="Zoom in"><Plus size={13} /></button>
          <button aria-label="Zoom out"><Minus size={13} /></button>
        </div>
        <button className="td-locate" aria-label="Center on my location"><Navigation size={13} /></button>

        <div className="td-panel">
          <div className="td-tabs" role="tablist">
            {TABS.map((t) => (
              <button key={t} role="tab" aria-selected={t === tab} onClick={() => setTab(t)}>{t}</button>
            ))}
          </div>
          {tab === "Order Details" ? (
            <>
              <div className="td-who2">
                <Avatar name={order.customer} tint="#3a3a3a" />
                <div><b>{order.customer}</b><span>Customer</span></div>
                <span className="td-pill" style={{ background: STATUS_COLOR[order.status] }}>{order.status}</span>
              </div>
              <div className="td-facts">
                <div><span className="td-lbl">Order ID</span><b>{order.id}</b></div>
                <div><span className="td-lbl">Weight</span><b>{order.weight}</b></div>
                <div><span className="td-lbl">Price</span><b>{order.price}</b></div>
                <div><span className="td-lbl">Name of product</span><b>{order.product}</b></div>
              </div>
            </>
          ) : (
            <p style={{ color: "var(--muted)", margin: "18px 0 6px" }}>{tab} will appear here.</p>
          )}
        </div>
      </section>
    </div>
  );
 }


export default Travelconsole
